import { AppThunk } from '@/store'
import { createAction, request } from '@/store/actions'

import {
  CLEAR_CURRENT_CHANNEL_CONNECTION,
  CREATE_CHANNEL_CONNECTION,
  DELETE_CHANNEL_CONNECTION,
  FETCH_CHANNEL_CONNECTIONS,
  SET_CURRENT_CHANNEL_CONNECTION,
  UPDATE_CHANNEL_CONNECTION
} from './actionTypes'
import { ChannelConnection } from './interfaces'

export const fetchChannelConnections = (): AppThunk => {
  return dispatch => {
    return dispatch(request('', FETCH_CHANNEL_CONNECTIONS, { method: 'GET' }, { service: 'channelconnections' }))
  }
}

export const deleteChannelConnection = (channelId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(`/${channelId}`, DELETE_CHANNEL_CONNECTION, { method: 'DELETE' }, { service: 'channelconnections' })
    )
  }
}

export const createChannelConnection = (channelConnection: ChannelConnection): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        ``,
        CREATE_CHANNEL_CONNECTION,
        { method: 'POST', body: channelConnection },
        { service: 'channelconnections' }
      )
    )
  }
}

export const updateChannelConnection = (channelConnection: ChannelConnection): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/${channelConnection.id}`,
        UPDATE_CHANNEL_CONNECTION,
        { method: 'PUT', body: channelConnection },
        { service: 'channelconnections' }
      )
    )
  }
}

export function setCurrentChannelConnection(channelConnection: ChannelConnection): AppThunk {
  return dispatch => {
    dispatch(createAction(SET_CURRENT_CHANNEL_CONNECTION, { channelConnection }))
  }
}

export function clearCurrentChannelConnection(): AppThunk {
  return dispatch => {
    dispatch(createAction(CLEAR_CURRENT_CHANNEL_CONNECTION))
  }
}
